import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationRole, AuthentService } from 'src/app/Services/authent.service';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

@Component({
  selector: 'app-gip-contract-list',
  templateUrl: './gipContractList.component.html',
  styleUrls: ['./gipContractList.component.css']
})
export class GipContractListComponent implements OnInit {

  constructor(
    private router: Router,
    private shareData: SharingDataService,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    public authService: AuthentService,
    ) { }

  urlString = "admin/MS_CONTRACT";
  resourceDefinition;
  groupName="MS_CONTRACT";
  authRole = AuthenticationRole;

  columns = [
    { name: "CONTRACT_NUMBER", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "CONTRACT_NAME", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "text", columnSearch: true, fromToFilter: false, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },
    { name: "CONTRACT_EXPIRATION_DT", visible: true, enableFilter: true, enableOrderBy: true, export: true, type: "date", columnSearch: false, fromToFilter: false, picklistTableName: null, function: "toFormPage", CSSClass: null, dateFromToFilter: [null, null], dateMonthFilter: null, orderByArrow: "", fromToFilterValues: ["", ""], picklistSelectedItems: [], picklistTable: [], search: "", format: null },


  ];

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
  }

  btnAddAction(){
    this.router.navigate(["/gipContractForm"]); 
  }

  action(parameters){
    this[parameters.action](parameters.element, parameters.column);
  }

  toFormPage(element, column){
    this.router.navigate(["/gipContractForm"], { queryParams: { id: element.ID, isEdit: true }, queryParamsHandling: 'merge' });

  }
}
